import React from 'react'

const DEFAULT_HOVER_RAISE_BY = 0

const withItemTileHover = (
  ItemTile,
  desktopOnly = true,
  raiseBy = DEFAULT_HOVER_RAISE_BY
) => {
  class ItemTileHover extends React.Component {
    constructor (props) {
      super(props)

      this.hoverOver = this.hoverOver.bind(this)
      this.hoverOut = this.hoverOut.bind(this)
      this.handleTransitionEnd = this.handleTransitionEnd.bind(this)
    }

    onDesktop () {
      return window.innerWidth > 768
    }

    hoverOver (itemTileElement, itemToReveal) {
      if (this.onDesktop() || !desktopOnly) {
        this.hovered = true

        if (!this.itemTileElement) {
          this.itemTileElement = itemTileElement
        }
        if (!this.coverContainer) {
          this.coverContainer = this.itemTileElement.querySelector(
            '.product-cover-container'
          )
        }
        this.itemTileElement.classList.add('hovered')
        this.lockItemCardHeight()

        if (itemToReveal) {
          this.itemToReveal = itemToReveal
          this.itemToRevealOriginalHeight = itemToReveal.clientHeight
          const heightGain = this.findItemToRevealHeightGain()
          this.raiseCover(heightGain)
        } else {
          this.raiseCover(raiseBy)
        }
      }
    }

    hoverOut () {
      if (this.onDesktop() || !desktopOnly) {
        this.hovered = false
        if (this.itemToReveal) {
          this.itemToReveal.style.maxHeight = `${
            this.itemToRevealOriginalHeight
          }px`
        }
        if (this.itemTileElement) {
          this.itemTileElement.classList.remove('hovered')
        }
        if (this.coverContainer) {
          this.coverContainer.style.paddingTop = '56.25%'
        }
      }
    }

    handleTransitionEnd () {
      if (!this.hovered) {
        this.unlockItemCardHeight()
      }
    }

    findItemToRevealHeightGain () {
      this.itemToReveal.style.maxHeight = 'none'
      let raisedHeight = this.itemToReveal.clientHeight

      return Math.max(0, raisedHeight - this.itemToRevealOriginalHeight)
    }

    lockItemCardHeight () {
      if (this.itemTileElement) {
        let cardCurrHeight = this.itemTileElement.clientHeight
        this.itemTileElement.style.maxHeight = `${cardCurrHeight}px`
        this.itemTileElement.style.minHeight = `${cardCurrHeight}px`
      }
    }

    raiseCover (raiseBy) {
      if (this.coverContainer) {
        this.coverContainer.style.paddingTop = `calc(56.25% - ${raiseBy}px)`
      }
    }

    unlockItemCardHeight () {
      if (this.itemTileElement) {
        this.itemTileElement.style.maxHeight = 'auto'
        this.itemTileElement.style.minHeight = 'auto'
      }
    }

    render () {
      return (
        <ItemTile
          hoverable
          {...this.props}
          mouseEnterAction={this.hoverOver}
          mouseLeaveAction={this.hoverOut}
          transitionEnd={this.handleTransitionEnd}
        />
      )
    }
  }

  return ItemTileHover
}
export default withItemTileHover
